import  React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';


const Price = ({ currency, number, precision }) => {
  currency = currency || 'USD';
  number = Number.parseFloat(number);

  if (_.isNil(precision)) {
    precision = 2;
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  }).format(number);
};

Price.propTypes = {
  number: PropTypes.number.isRequired,
  currency: PropTypes.string
};

export default Price;
